<div class="wrapper">
  <div class="prefix">
    <img [src]="logo" />
    <span>{{prefix}}</span>
  </div>
  <input
    matInput
    preventSpace
    (blur)="blur()"
    (keyup)="keyup()"
    (keyup.enter)="keyup()"
    (input)="change()"
    [disabled]="disabled ||readOnly"
    [(ngModel)]="value"
    type="number"
    [placeholder]="placeholder"
    onkeypress="return /[0-9 .]/i.test(event.key)"

  />
</div>
